import { render, staticRenderFns } from "./ProductoTiendaConfigByTiendaComponent.vue?vue&type=template&id=7a7948f3&"
import script from "./ProductoTiendaConfigByTiendaComponent.vue?vue&type=script&lang=js&"
export * from "./ProductoTiendaConfigByTiendaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports